import type * as Types from 'app/types/graphql';

import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type ThemePageDeleteMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type ThemePageDeleteMutationResponse = Pick<Types.Mutation, 'themePageDelete'>;

export const ThemePageDeleteDocument = `
    mutation ThemePageDelete($id: ID!) {
  themePageDelete(id: $id)
}
    `;

export const useThemePageDeleteMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ThemePageDeleteMutationResponse,
    TError,
    ThemePageDeleteMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ThemePageDeleteMutationResponse,
    TError,
    ThemePageDeleteMutationVariables,
    TContext
  >(
    ['ThemePageDelete'],
    (variables?: ThemePageDeleteMutationVariables) =>
      appFetcher<ThemePageDeleteMutationResponse, ThemePageDeleteMutationVariables>(
        ThemePageDeleteDocument,
        variables,
      )(),
    options,
  );
};

useThemePageDeleteMutation.getKey = () => ['ThemePageDelete'];
